<template>
    <div>
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!--被下线-->
        <div class="popFixed" v-if="offlinePop">
            <div class="masking"></div>
            <div class="tcCon">
                <div class="item">
                    <span>{{$t("message.point")}}</span>
                    <p>{{$t("message.info_register")}}</p>
                </div>
                <div class="btnCon only">
                    <span @click="goLogin">{{$t("message.register")}}</span>
                </div>
            </div>
        </div>
        <!--服务器断开连接-->
        <div class="popFixed" v-if="((initTrade && user.loginname && socket.tradeSocket && !socket.tradeSocket.connected) || (initQuote && socket.quoteSocket && !socket.quoteSocket.connected)) && !$route.meta.serverLink">
            <div class="masking"></div>
            <div class="tcCon">
                <div class="item">
                    <span>{{$t("message.point")}}</span>
                    <p>{{$t("message.poorNetwork")}}</p>
                </div>
                <div class="btnCon only">
                    <span @click="Refresh">{{$t("trade.noData.reload")}}</span>
                </div>
            </div>
        </div>
        <!--登录失败-->
        <div class="popFixed" v-if="loginFailed">
            <div class="masking"></div>
            <div class="tcCon">
                <div class="item">
                    <span>{{$t("message.point")}}</span>
                    <p>{{errMessage}}</p>
                </div>
                <div class="btnCon only">
                    <span @click="goLogin">{{$t("message.register")}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { io } from 'socket.io-client'
    import {mapState} from 'vuex'
    import Store from '@/store'
    import AccountUtil from '@/utils/accountUtil'
    import TradeUtil from '@/utils/tradeUtil'
    import Constant from '@/utils/Constant'
    import QuoteUtil from '@/utils/quoteUtil'
    import tradeUtil from "../utils/tradeUtil";
    import api from '@/plugins/api'

    export default {
        // vue项目中建议用(param)=>{} 替代 function(param){},这样this不会指向function本身;
        name: "InitData",
        data() {
            return {
                offlinePop: false,
                emitPop: false,
                quoteState: true,//是否允许行情服务器去登录
                quoteConnectThread:0,//行情服务器尝试连接数
                tradeState: true,//是否允许交易服务器去登录
                tradeConnectThread:0,//交易服务器尝试连接数
                initQuote:false,//行情服务器连接成功
                initTrade:false,//交易服务器连接成功
                loginFailed:false,
                errMessage:"",
                productList:process.env.VUE_APP_PRODUCTS.split(","),
            }
        },
        beforeCreate() {
            /* //交易socket,socket不存在或断开时
                    if ((Store.state.user.loginname && !Store.state.socket.tradeSocket) || (Store.state.socket.tradeSocket && !Store.state.socket.tradeSocket.connected)) {
                        //新建socket
                        if (String(Store.state.user.loginname).startsWith("8")) Store.dispatch("setTradeSocket", SocketIO(process.env.VUE_APP_TRADE_REAL));//真实
                        else Store.dispatch("setTradeSocket", SocketIO(process.env.VUE_APP_TRADE_DEMO));//模拟
                    }*/
            // 行情服务器
            if (
            !Store.state.socket.quoteSocket ||
            (Store.state.socket.quoteSocket &&
                !Store.state.socket.quoteSocket.connected)
            ) {
            const url =
                !Store.state.user.loginname ||
                String(Store.state.user.loginname).startsWith('8')
                ? process.env.VUE_APP_QUOTE_REAL
                : process.env.VUE_APP_QUOTE_DEMO

            let quoteSocket
            if (process.env.NODE_ENV == 'development') {
                if (!Store.state.user.loginname || String(Store.state.user.loginname).startsWith('8')) {
                quoteSocket = io(url, {
                    path: process.env.VUE_APP_QUOTE_REAL_PATH
                })
                } else {
                quoteSocket = io(url, {
                    path: process.env.VUE_APP_QUOTE_DEMO_PATH
                })
                }
            } else {
                quoteSocket = io(url)
            }
            Store.dispatch('setQuoteSocket', quoteSocket)
            // const ioUrl = getSocketIoUrl(url)
            // Store.dispatch(
            //   'setQuoteSocket',
            //   io(ioUrl.uri, { path: ioUrl.path })
            // )
            } // 外网
        },
        computed: {
            ...mapState(['quote', 'socket', 'account', 'group', 'symbolInfo', 'tradeData', 'user']),
        },
        created() {
            //初始化行情数据
            this.quoteSocketInit();
        },
        methods: {
            quoteSocketInit() {
                this.socket.quoteSocket.on("connect", (param, data) => {
                    const thread = ++this.quoteConnectThread;
                    if (this.quoteState) {
                        this.quoteState = false;
                        //登录行情服务器
                        setTimeout(()=>{
                            if (thread > 1) return;
                            console.log(new Date().getTime()+":行情socket连接成功("+ thread +")");
                            this.socket.quoteSocket.emit("addme", this.user.loginname || 'Guest', this.user.pwd || 'Guest', this.user.companyId || 8);
                        },10);
                    }
                    this.initQuote = true;
                });
                this.socket.quoteSocket.on("HeartBeat", (param, data) => {
                    this.socket.quoteSocket.emit("Pong", {beat: 1});
                });
                this.socket.quoteSocket.on("tick", (param, data) => {
                    //此处有坑，请注意（判断报价时间，过滤掉上一口报价的重复推送）
                    QuoteUtil.updateTickList(param, data, this.quote.tickList);
                    Store.dispatch("setQuoteTickList", this.quote.tickList);
                });
                //数据字典
                this.socket.quoteSocket.on("init_prd_notify", (param, data) => {
                    if (param.Code != 0) return;
                    const obj = QuoteUtil.initNotify(param, data);
                    Store.dispatch("setQuoteNotify", obj.notify);

                    //字典数据初始化完成，加载交易数据
                    this.initTradeData();

                    //订阅数据字典有的数据
                    this.socket.quoteSocket.emit('request', Number(Constant.Req.subsTick), {
                        "UserID": this.account.userId,
                        "GroupID": this.account.groupId,
                        "uiCodeIDList": this.productList
                    });
                    //分页请求数据字典中数据的最后一口报价(个人猜测:一次请求产品不能超过15个,否则请求失效)
                    let lastTick = {};
                    for (const i in this.productList) {
                        lastTick[i] = this.productList[i];
                    }
                    this.socket.quoteSocket.emit('request', Number(Constant.Req.lastTick), lastTick);
                });
                //行情历史数据
                this.socket.quoteSocket.on("quote_query", (param, data) => {
                    const seq = param.seq;
                    let history = [];
                    if (String(param.seq).endsWith("1") || String(param.seq).endsWith("2") || String(param.seq).endsWith("3")) {
                        //5/15/30分钟K线需要将时间向下取整到5分钟
                        const fiveMinutesInMs = 5 * 60;
                        for (const i in data) {
                            data[i].tm = Math.floor(data[i].tm / fiveMinutesInMs) * fiveMinutesInMs
                            history.push(data[i]);
                        }
                    }else{
                        for (const i in data) {
                            history.push(data[i]);
                        }
                    }
                    history.reverse();
                    if (String(param.seq).endsWith("2")) history = TradeUtil.transKcharts(1, history);
                    else if (String(param.seq).endsWith("3")) history = TradeUtil.transKcharts(2, history);
                    this.quote.historyTick[seq] = history;
                    Store.dispatch("setHistoryTick", this.quote.historyTick);
                });
                //行情历史数据
                this.socket.quoteSocket.on("uptrend_query", (param, data) => {
                    const seq = param.seq;
                    let history = [];
                    for (const i in data) {
                        history.push(data[i]);
                    }
                    this.quote.historyTick[seq] = history;
                    Store.dispatch("setHistoryTick", this.quote.historyTick);
                });
                //逻辑未知
                this.socket.quoteSocket.on("tick_WebUI", (param, data) => {

                });
                //逻辑未知
                this.socket.quoteSocket.on("LoginComplete_WebUI", (param, data) => {

                });
                //disconnect
                this.socket.quoteSocket.on("disconnect", (param, data) => {
                    this.quoteState = false;
                    this.socket.quoteSocket.close();
                });
            },
            initTradeData() {
                // 交易socket,socket不存在或断开时
                if (
                (Store.state.user.loginname && !Store.state.socket.tradeSocket) ||
                (Store.state.socket.tradeSocket &&
                    !Store.state.socket.tradeSocket.connected)
                ) {
                // 新建socket
                const url = String(Store.state.user.loginname).startsWith('8')
                    ? process.env.VUE_APP_TRADE_REAL
                    : process.env.VUE_APP_TRADE_DEMO

                let tradeSocket
                if (process.env.NODE_ENV == 'development') {
                    if (!Store.state.user.loginname || String(Store.state.user.loginname).startsWith('8')) {
                    tradeSocket = io(url, {
                        path: process.env.VUE_APP_TRADE_REAL_PATH
                    })
                    } else {
                    tradeSocket = io(url, {
                        path: process.env.VUE_APP_TRADE_DEMO_PATH
                    })
                    }
                } else {
                    tradeSocket = io(url)
                }

                Store.dispatch('setTradeSocket', tradeSocket)
                // const ioUrl = getSocketIoUrl(url)
                // Store.dispatch('setTradeSocket', io(ioUrl.uri, { path: ioUrl.path }))
                }
                // 行情字典处理完成，接收交易数据
                if (this.socket.tradeSocket) this.tradeSocketInit()
            },
            tradeSocketInit() {
                this.socket.tradeSocket.on("connect", (param, data) => {
                    const thread = ++this.tradeConnectThread;
                    if (this.tradeState) {
                        this.tradeState = false;
                        setTimeout(()=>{
                            if (thread > 1) return;//防止重复登录
                            console.log(new Date().getTime()+":交易socket连接成功("+ thread +")");
                            this.socket.tradeSocket.emit("addme", this.user.loginname, this.user.pwd, this.user.companyId);
                        },10);
                    }
                    this.initTrade = true;
                });
                this.socket.tradeSocket.on("HeartBeat", (param, data) => {
                    this.socket.tradeSocket.emit('Pong', {beat: 1});
                });
                this.socket.tradeSocket.on("ServerGetTime", (param, data) => {
                    //获取系统时间
                    let initSystemTime = param.ServerTime * 1000;
                });
                this.socket.tradeSocket.on("UserLoginInfo", (param, data) => {
                    if (param.Code != 0) return;
                    AccountUtil.initData(param, this.account);
                    Store.dispatch("setAccount", this.account);
                });
                //交易时间
                this.socket.tradeSocket.on("GroupTradeTimeList", (param, data) => {
                    if (param.Code != 0) return;
                    if (param.Offset == param.Count) this.symbolInfo.symbolTime = [];//重新拉取时，清空数据
                    tradeUtil.initTradeTimeList(param, data, this.symbolInfo.symbolTime);
                    //如果没有查询完，分页查询下一页数据
                    Store.dispatch("setSymbolTime", this.symbolInfo.symbolTime);
                    if (param.Offset < param.Total) this.socket.tradeSocket.emit('request', Number(Constant.Req.tradeTimes), {
                        "ID": this.account.groupId,
                        "Token": this.account.token,
                        "Offset": param.Offset
                    });
                });
                //交易时间
                this.socket.tradeSocket.on("TradeTimeUpdate", (param, data) => {
                    //如果没有查询完，分页查询下一页数据
                    this.socket.tradeSocket.emit('request', Number(Constant.Req.tradeTimes), {
                        "ID": this.account.groupId,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                //交易时间
                this.socket.tradeSocket.on("TradeTimeAdd", (param, data) => {
                    //如果没有查询完，分页查询下一页数据
                    this.socket.tradeSocket.emit('request', Number(Constant.Req.tradeTimes), {
                        "ID": this.account.groupId,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                //交易时间
                this.socket.tradeSocket.on("TradeTimeDelete", (param, data) => {
                    //如果没有查询完，分页查询下一页数据
                    this.socket.tradeSocket.emit('request', Number(Constant.Req.tradeTimes), {
                        "ID": this.account.groupId,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                this.socket.tradeSocket.on("AccountUpdate", (param, data) => {
                    if (param.Code != 0) return;
                    AccountUtil.initData(param, this.account);
                    Store.dispatch("setAccount", this.account);
                });
                this.socket.tradeSocket.on("AccountGet", (param, data) => {
                    if (param.Code != 0) return;
                    AccountUtil.initData(param, this.account);
                    Store.dispatch("setAccount", this.account);
                });
                this.socket.tradeSocket.on("GroupGet", (param, data) => {
                    if (param.Code != 0) return;
                    AccountUtil.initGroup(param, this.group);
                    Store.dispatch("setGroup", this.group);
                    //交易服务器信息
                    this.socket.tradeSocket.emit('request', Number(Constant.Req.serverGet), {
                        "AccountID": this.account.accountID,
                        "Token": this.account.token,
                        "ServerID": this.group.serverId
                    });
                });
                this.socket.tradeSocket.on("GroupUpdate", (param, data) => {
                    if (param.Code != 0) return;
                    AccountUtil.updateGroup(param, this.group);
                    Store.dispatch("setGroup", this.group);
                });
                //服务器信息
                this.socket.tradeSocket.on("ServerGet", (param, data) => {
                    if (param.Code != 0) return;
                    Store.dispatch("setServerInfo", param);
                });
                this.socket.tradeSocket.on("GroupSymbolList", (param, data) => {
                    if (param.Code != 0) return;
                    if (param.Offset == param.Count) this.symbolInfo.symbolMap = {};//重新拉取时，清空数据
                    TradeUtil.initSymbolList(param, data, this.symbolInfo.symbolMap);
                    Store.dispatch("setSymbolMap", this.symbolInfo.symbolMap);
                    //如果没有查询完，分页查询下一页数据
                    if (param.Offset < param.Total) this.socket.tradeSocket.emit('request', Number(Constant.Req.symbols), {
                        "ID": this.account.groupId,
                        "Token": this.account.token,
                        "Offset": param.Offset
                    });
                    if (param.Offset == param.Total) {
                        //交易数据列表处理完成再拉取用户交易数据列表
                        //请求当日成交记录
                        this.socket.tradeSocket.emit('request', Number(Constant.Req.deals), {
                            "AccountID": this.account.accountID,
                            "Token": this.account.token,
                            "Offset": 0
                        });
                        //请求挂单记录
                        this.socket.tradeSocket.emit('request', Number(Constant.Req.pendings), {
                            "AccountID": this.account.accountID,
                            "Token": this.account.token,
                            "Offset": 0
                        });
                        //持仓记录
                        this.socket.tradeSocket.emit('request', Number(Constant.Req.positions), {
                            "AccountID": this.account.accountID,
                            "Token": this.account.token,
                            "Offset": 0
                        });
                    }
                });
                this.socket.tradeSocket.on("SymbolUpdate", (param, data) => {
                    //数据改变，重新拉取数据
                    if (param.Offset < param.Total) this.socket.tradeSocket.emit('request', Number(Constant.Req.symbols), {
                        "ID": this.account.groupId,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                this.socket.tradeSocket.on("SymbolAdd", (param, data) => {
                    //数据改变，重新拉取数据
                    if (param.Offset < param.Total) this.socket.tradeSocket.emit('request', Number(Constant.Req.symbols), {
                        "ID": this.account.groupId,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                this.socket.tradeSocket.on("SymbolDelete", (param, data) => {
                    //数据改变，重新拉取数据
                    if (param.Offset < param.Total) this.socket.tradeSocket.emit('request', Number(Constant.Req.symbols), {
                        "ID": this.account.groupId,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                //当日成交记录，(当日盈亏:过滤掉开仓数据，留下平仓数据即可)
                this.socket.tradeSocket.on("DealTodayListRet", (param, data) => {
                    if (param.Code != 0) return;
                    // if (param.Offset == param.Count) this.tradeData.dayDeal = [];//重新拉取时，清空数据
                    tradeUtil.initDayDeal(param, data, this.tradeData.dayDeal);
                    Store.dispatch("setDayDeal", this.tradeData.dayDeal);
                    if (param.Offset < param.Total) this.socket.tradeSocket.emit('request', Number(Constant.Req.deals), {
                        "AccountID": this.account.accountID,
                        "Token": this.account.token,
                        "Offset": param.Offset
                    });
                });
                this.socket.tradeSocket.on("DealAddRet", (param, data) => {// （开仓、平仓）
                    Store.dispatch("setDealAddRet",param);
                    //请求当日成交记录
                    this.socket.tradeSocket.emit('request', Number(Constant.Req.deals), {
                        "AccountID": this.account.accountID,
                        "Token": this.account.token,
                        "Offset": 0
                    });

                });
                //挂单记录
                this.socket.tradeSocket.on("OrderListRet", (param, data) => {
                    if (param.Code != 0) return;
                    if (param.Offset == param.Count) this.tradeData.pending = [];//重新拉取时，清空数据
                    tradeUtil.initPending(param, data, this.tradeData.pending);
                    Store.dispatch("setPending", this.tradeData.pending);
                    if (param.Offset < param.Total) this.socket.tradeSocket.emit('request', Number(Constant.Req.pendings), {
                        "AccountID": this.account.accountID,
                        "Token": this.account.token,
                        "Offset": param.Offset
                    });
                });
                this.socket.tradeSocket.on("OrderAddRet", (param, data) => {// (挂单下单[等待的委托单])
                    //暂时用此作为下单结果的判定（正确性待定）
                    this.$store.dispatch("setOrderAddRet", param);
                    //请求挂单记录
                    this.socket.tradeSocket.emit('request', Number(Constant.Req.pendings), {
                        "AccountID": this.account.accountID,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                this.socket.tradeSocket.on("OrderUpdateRet", (param, data) => {// (改单[委托单]、挂单到价系统成交)
                    Store.dispatch("setOrderUpdateRet", param);
                    //请求挂单记录
                    this.socket.tradeSocket.emit('request', Number(Constant.Req.pendings), {
                        "AccountID": this.account.accountID,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                this.socket.tradeSocket.on("OrderCancelRet", (param, data) => {// (撤单)
                    Store.dispatch("setOrderCancelRet", param);
                    //请求挂单记录
                    this.socket.tradeSocket.emit('request', Number(Constant.Req.pendings), {
                        "AccountID": this.account.accountID,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                //持仓记录
                this.socket.tradeSocket.on("PositionListRet", (param, data) => {
                    if (param.Code != 0) return;
                    if (param.Offset == param.Count) this.tradeData.position = [];//重新拉取时，情况数据
                    tradeUtil.initPosition(param, data, this.tradeData.position);
                    Store.dispatch("setPosition", this.tradeData.position);
                    if (param.Offset < param.Total) this.socket.tradeSocket.emit('request', Number(Constant.Req.positions), {
                        "AccountID": this.account.accountID,
                        "Token": this.account.token,
                        "Offset": param.Offset
                    });
                });
                this.socket.tradeSocket.on("PositionAddRet", (param, data) => {// (市价下单)
                    Store.dispatch("setPositionAddRet", param);
                    //持仓记录
                    this.socket.tradeSocket.emit('request', Number(Constant.Req.positions), {
                        "AccountID": this.account.accountID,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                this.socket.tradeSocket.on("PositionUpdateRet", (param, data) => {
                    this.$store.dispatch("setPositionUpdateRet", param);
                    //持仓记录
                    this.socket.tradeSocket.emit('request', Number(Constant.Req.positions), {
                        "AccountID": this.account.accountID,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                this.socket.tradeSocket.on("PositionUpdate", (param, data) => {
                });
                //层级保证金
                this.socket.tradeSocket.on("GroupMarginList", (param, data) => {
                    if (param.Code != 0) return;
                    if (param.Offset == param.Count && param.Count != 0) this.symbolInfo.marginList = [];//重新拉取时，情况数据
                    TradeUtil.initMarginList(param, data, this.symbolInfo.marginList);
                    this.$store.dispatch("setMarginList", this.symbolInfo.marginList);
                    if (param.Offset < param.Total) this.socket.tradeSocket.emit('request', Number(Constant.Req.marginLevels), {
                        "ID": this.account.groupId,
                        "Token": this.account.token,
                        "Offset": param.Offset
                    });
                });
                //层级保证金更新
                this.socket.tradeSocket.on("SymbolMarginLevelBatchUpdate", (param, data) => {
                    if (param.Code != 0) return;
                    this.socket.tradeSocket.emit('request', Number(Constant.Req.marginLevels), {
                        "ID": this.account.groupId,
                        "Token": this.account.token,
                        "Offset": 0
                    });
                });
                //此账户在其他地方登陆，强制用户退出
                this.socket.tradeSocket.on("UserForceLogout", (param, data) => {
                    //被下线
                    if (param.Reason==3){
                        this.$store.dispatch("setUser", {});
                        this.$router.push({path: '/login'})

                    }else {
                        this.offlinePop = !this.offlinePop;
                        this.$store.dispatch("setUser", {});
                    }
                });
                //不可知道收到的是什么数据
                this.socket.tradeSocket.on("SymbolUpdate_WebUI", (param, data) => {

                });
                this.socket.tradeSocket.on("SimpleResponse", (param, data) => {
                    this.$store.dispatch("setSimpleResponse", param);
                });
                this.socket.tradeSocket.on("loginR", (param, data) => {
                    //登录失败
                    this.errMessage=JSON.stringify(param);
                    this.loginFailed=!this.loginFailed
                });
                //disconnect
                this.socket.tradeSocket.on("disconnect", (param, data) => {
                    this.tradeState = false;
                    this.socket.tradeSocket.close();
                });
            },
            goLogin() {
                this.$store.dispatch("setUser", {});
                window.location.href = process.env.VUE_APP_PATH + "login";
            },
            Refresh() {
                window.location.reload(true);
            },
            autoLogin(){
                api.getCacheCustomerByToken(this.user.token).then(res => {
                        if (res.status == 200) {
                            if (res.data.code != 200) {
                                this.errMessage = this.$t("message.info_tokenErr");
                                this.loginFailed = !this.loginFailed;
                            }
                        }
                        else  {
                            this.errMessage = this.$t("message.info_tokenErr");
                            this.loginFailed = !this.loginFailed;
                        }
                    }
                );
            }
        },
        mounted(){
            if(this.user.loginname){
                this.autoLogin();
                setInterval(this.autoLogin,36000000)
            }
        }
    }
</script>
